var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clock_1_",
    "data-name": "clock (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.394,
    height: 30.394,
    viewBox: "0 0 30.394 30.394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_224749",
    "data-name": "Path 224749",
    d: "M24.695,30.394H5.7a5.7,5.7,0,0,1-5.7-5.7V5.7A5.7,5.7,0,0,1,5.7,0h19a5.7,5.7,0,0,1,5.7,5.7v19A5.7,5.7,0,0,1,24.695,30.394Zm0,0",
    fill: "#e8e8e8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_224750",
    "data-name": "Path 224750",
    d: "M135.6,128a7.6,7.6,0,1,0,7.6,7.6A7.607,7.607,0,0,0,135.6,128Zm3.614,11.529a.633.633,0,0,1-.895,0l-3.166-3.166a.632.632,0,0,1-.185-.447V131.8a.634.634,0,1,1,1.267,0v3.853l2.98,2.981A.636.636,0,0,1,139.212,139.529Zm0,0",
    transform: "translate(-120.402 -120.402)",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.78edec0a639ba7416c72d6770a8974a9.svg";
export { ForwardRef as ReactComponent };